import { StepItem } from "../../../shared/components/Steps";
import { PAYROLL_RUN_APPROVAL_STAGES } from "../constants";
import { PayrollRunStatus } from "../types";

/**
 * Maps a payroll run status to the index of the stage that is currently active
 * within the ordered approval window (Open → Approval → Finalized → Paid).
 * `activeIndex` past the last stage means every stage is complete.
 */
const STATUS_TO_ACTIVE_STAGE: Record<
  PayrollRunStatus,
  { activeIndex: number; failed?: boolean }
> = {
  pending: { activeIndex: 0 },
  opened: { activeIndex: 1 },
  processing: { activeIndex: 2 },
  completed: { activeIndex: PAYROLL_RUN_APPROVAL_STAGES.length },
  failed: { activeIndex: 1, failed: true }
};

export const selectorPayrollRunApprovalSteps = (
  status: PayrollRunStatus
): StepItem[] => {
  const { activeIndex, failed } = STATUS_TO_ACTIVE_STAGE[status];

  return PAYROLL_RUN_APPROVAL_STAGES.map((title, index) => {
    if (index < activeIndex) {
      return { title, status: "Complete" };
    }

    if (index === activeIndex) {
      return { title, status: failed ? "Failed" : "Active" };
    }

    return { title, status: "Pending" };
  });
};
